<template>
    <div id="SpecialMessages">
        <div class="botao-regulamento text-center cursor-pointer text-uppercase text-yanone text-bold bg-info-4 text-white mb-0"
             @click="showCovidInfo = true">
            Chico Rei na luta contra o COVID-19! Produção e doação de máscaras e fortalecimento de pequenos produtores.
            <span class="text-underline">CONFIRA!</span>
        </div>

        <Modal v-model="showCovidInfo" class="modal-regulamento" style="line-height:24px ">
            <template v-slot:title><strong>Resiliência. Reinvenção. Reconversão.</strong></template>
            <div class="card-block">
                <div class="regulamento-texto">
                    <p>Vivemos tempos que, apesar de efêmeros, são duros. A pandemia do COVID-19 exige adequação.</p>


                    <p>A <b>Chico Rei</b> é, desde o berço, feita de pessoas para pessoas. Em momento de risco singular, precisamos assumir papel ativo para protegê-las de forma eficaz. Isso vale para as quase cem pessoas que trabalham por aqui, para você nosso cliente, fornecedores, parceiros e todas as outras que alcançamos, direta ou indiretamente.</p>


                    <p>Aproveitando nosso conhecimento na produção de artigos de vestuário, ingressamos na corrente da reconversão industrial. Vamos colocar a bagagem adquirida nestes mais de doze anos aos serviços do nosso entorno.</p>


                    <p>Estamos iniciando a produção de máscaras que serão distribuídas gratuitamente para o sistema prisional do estado de Minas Gerais e o Departamento Municipal de Limpeza Urbana de nossa terra Juiz de Fora (DEMLURB). Esses equipamentos de proteção individual são importantíssimos na guerra contra a disseminação do vírus. A demanda por máscaras no momento supera a capacidade produtiva do país. Mas, juntando forças, conseguiremos atendê-la em breve. Também estamos disponíveis para atender a pedidos de empresas da região.</p>


                    <p>Outra iniciativa é a criação de uma rede de pequenos produtores caseiros. De pessoas que estão sendo severamente afetadas. Famílias em quarentena que possuem negócios de confecção e estamparia em seus lares. Esses pais, mães, filhos e filhas precisam de um impulso para continuarem firmes durante este período de crise sanitária e econômica. E nós precisamos da ajuda deles na produção de nossas camisetas.</p>


                    <p>A arte e a criatividade sempre foram válvulas de escape em tempos de crise. Não será diferente desta vez. Estamos tomando medidas e fazendo o possível para proporcionar essa abstração. Nos colocamos à disposição para tornar o momento mais leve. E contamos contigo para manter a roda girando.</p>
                </div>
            </div>
            <div class="card-block text-right">
                <button type="button" class="btn" @click="showCovidInfo = false">Fechar</button>
            </div>
        </Modal>
    </div>
</template>

<script>
    import Modal from "./container/Modal";
    import {timeHandler} from "../../../common/common";

    export default {
        name: 'SpecialMessages',
        components: {Modal},

        data() {
            return {
                showCovidInfo: false
            }
        },
    }
</script>